import React, { ReactNode } from 'react';
import { useUserDataContext } from 'components/UserDataContext/context';
import { useGetPermission } from 'utils/hooks/useGetPermission';
import { ROLES } from 'utils/consts/roles';

export type CatalogLinkProps = {
  children: ReactNode;
  href: string;
  target?: string;
  rel?: string;
};

export const CatalogLink = ({ children, href, target, rel }: CatalogLinkProps) => {
  const { userData } = useUserDataContext();
  const catPermission = useGetPermission(ROLES.catalogs, userData, true);
  return catPermission ? (
    <a href={href} target={target} rel={rel}>
      {children}
    </a>
  ) : (
    <>{children}</>
  );
};
